import React from "react";

function VMC(){
    return (
        <section className="section border-top">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 mb-4 text-center">
                        <h3 className="main-heading">Vision, Mission and Values</h3>
                        <div className="underline mx-auto"></div>
                    </div>
                    <div className="col-md-4 text-center">
                    <h5>Vision</h5>
                        <p>
                            Our vision is to be the most highly respected professional firm where we seek to build strong 
                            and lasting relationships with our clients by providing them quality services which are personalized, 
                            reliable and value driven. Where clients will be confident that their interests and business are being 
                            cared for by a trusted firm that enjoys working with them and one another. 
                        </p>
                    </div>
                    <div className="col-md-4 text-center">
                        <h5>Mission</h5>
                        <p>
                            We will provide businesses, entrepreneurs and individuals with the highest quality accounting, auditing, 
                            tax planning and business advisory services delivered in a timely, efficient and innovative manner by a 
                            professional team that clearly enjoys working together to exceed their clients’ needs and expectations. 
                        </p>
                    </div>
                    <div className="col-md-4 text-center">
                        <h5>Core Values</h5>
                        <p>
                            Honesty, integrity and ethics in all we do. Teamwork in an atmosphere of mutual respect. Employ talented, caring and responsible people. Develop leaders for the growth and health of our Firm.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default VMC;